export const enum StyleConstants {
	NAV_BAR_HEIGHT = '4.1rem',
	BREADCRUMB_HEIGHT = '3.5rem',
	SIDE_BAR_WIDTH = '16.7rem',
	SIDE_BAR_WIDTH_COLLAPSED = '5.5rem',
}
